import dlbclIndex from './dlbcl/index.json';
import dlbclNodes from './dlbcl/nodes.json';
import dlbclEdges from './dlbcl/edges.json';

import flIndex from './fl/index.json';
import flNodes from './fl/nodes.json';
import flEdges from './fl/edges.json';

import mclIndex from './mcl/index.json';
import mclNodes from './mcl/nodes.json';
import mclEdges from './mcl/edges.json';

import mzlIndex from './mzl/index.json';
import mzlNodes from './mzl/nodes.json';
import mzlEdges from './mzl/edges.json';

import burkittIndex from './burkitt/index.json';
import burkittNodes from './burkitt/nodes.json';
import burkittEdges from './burkitt/edges.json';

import pmbclIndex from './pmbcl/index.json';
import pmbclNodes from './pmbcl/nodes.json';
import pmbclEdges from './pmbcl/edges.json';

import cllIndex from './cll/index.json';
import cllNodes from './cll/nodes.json';
import cllEdges from './cll/edges.json';

import hlIndex from './hl/index.json';
import hlNodes from './hl/nodes.json';
import hlEdges from './hl/edges.json';

import mfssIndex from './mf-ss/index.json';
import mfssNodes from './mf-ss/nodes.json';
import mfssEdges from './mf-ss/edges.json';

import hivBclIndex from './hiv-bcl/index.json';
import hivBclNodes from './hiv-bcl/nodes.json';
import hivBclEdges from './hiv-bcl/edges.json';

import ptldIndex from './ptld/index.json';
import ptldNodes from './ptld/nodes.json';
import ptldEdges from './ptld/edges.json';

import hgblIndex from './hgbl/index.json';
import hgblNodes from './hgbl/nodes.json';
import hgblEdges from './hgbl/edges.json';

import htDlbclIndex from './ht-dlbcl/index.json';
import htDlbclNodes from './ht-dlbcl/nodes.json';
import htDlbclEdges from './ht-dlbcl/edges.json';

import wmIndex from './wm/index.json';
import wmNodes from './wm/nodes.json';
import wmEdges from './wm/edges.json';

import hclIndex from './hcl/index.json';
import hclNodes from './hcl/nodes.json';
import hclEdges from './hcl/edges.json';

import pcnslIndex from './pcnsl/index.json';
import pcnslNodes from './pcnsl/nodes.json';
import pcnslEdges from './pcnsl/edges.json';

import ptclIndex from './ptcl/index.json';
import ptclNodes from './ptcl/nodes.json';
import ptclEdges from './ptcl/edges.json';

import atllIndex from './atll/index.json';
import atllNodes from './atll/nodes.json';
import atllEdges from './atll/edges.json';

import enktlIndex from './enktl/index.json';
import enktlNodes from './enktl/nodes.json';
import enktlEdges from './enktl/edges.json';

const registryBase = [
  {
    id: 'dlbcl',
    name: 'Diffuse Large B-Cell Lymphoma',
    subtitle: 'NCCN Guidelines for B-Cell Lymphomas — DLBCL Algorithm',
    category: 'B-Cell Lymphoma',
    version: '2.2025',
    pageCount: 5,
    nccnUrl: 'https://www.nccn.org/professionals/physician_gls/pdf/b-cell.pdf',
  },
  {
    id: 'fl',
    name: 'Follicular Lymphoma',
    subtitle: 'NCCN Guidelines for B-Cell Lymphomas — FL Algorithm',
    category: 'B-Cell Lymphoma',
    version: '1.2026',
    pageCount: 6,
    nccnUrl: 'https://www.nccn.org/professionals/physician_gls/pdf/b-cell.pdf',
  },
  {
    id: 'mcl',
    name: 'Mantle Cell Lymphoma',
    subtitle: 'NCCN Guidelines for B-Cell Lymphomas — MCL Algorithm',
    category: 'B-Cell Lymphoma',
    version: '2.2025',
    pageCount: 5,
    nccnUrl: 'https://www.nccn.org/professionals/physician_gls/pdf/b-cell.pdf',
  },
  {
    id: 'mzl',
    name: 'Marginal Zone Lymphoma',
    subtitle: 'NCCN Guidelines for B-Cell Lymphomas — MZL Algorithm',
    category: 'B-Cell Lymphoma',
    version: '2.2025',
    pageCount: 5,
    nccnUrl: 'https://www.nccn.org/professionals/physician_gls/pdf/b-cell.pdf',
  },
  {
    id: 'burkitt',
    name: 'Burkitt Lymphoma',
    subtitle: 'NCCN Guidelines for B-Cell Lymphomas — BL Algorithm',
    category: 'B-Cell Lymphoma',
    version: '2.2025',
    pageCount: 4,
    nccnUrl: 'https://www.nccn.org/professionals/physician_gls/pdf/b-cell.pdf',
  },
  {
    id: 'pmbcl',
    name: 'Primary Mediastinal B-Cell Lymphoma',
    subtitle: 'NCCN Guidelines for B-Cell Lymphomas — PMBCL Algorithm',
    category: 'B-Cell Lymphoma',
    version: '2.2025',
    pageCount: 4,
    nccnUrl: 'https://www.nccn.org/professionals/physician_gls/pdf/b-cell.pdf',
  },
  {
    id: 'cll',
    name: 'CLL / Small Lymphocytic Lymphoma',
    subtitle: 'NCCN Guidelines for CLL/SLL',
    category: 'CLL/SLL',
    version: '2.2025',
    pageCount: 6,
    nccnUrl: 'https://www.nccn.org/professionals/physician_gls/pdf/cll.pdf',
  },
  {
    id: 'hl',
    name: 'Hodgkin Lymphoma',
    subtitle: 'NCCN Guidelines for Hodgkin Lymphoma — cHL & NLPHL',
    category: 'Hodgkin Lymphoma',
    version: '2.2025',
    pageCount: 6,
    nccnUrl: 'https://www.nccn.org/professionals/physician_gls/pdf/hodgkins.pdf',
  },
  {
    id: 'mf-ss',
    name: 'Mycosis Fungoides / Sezary Syndrome',
    subtitle: 'NCCN Guidelines for Primary Cutaneous Lymphomas — MF/SS',
    category: 'Cutaneous Lymphoma',
    version: '1.2026',
    pageCount: 5,
    nccnUrl: 'https://www.nccn.org/professionals/physician_gls/pdf/primary_cutaneous.pdf',
  },
  {
    id: 'hiv-bcl',
    name: 'HIV-Related B-Cell Lymphomas',
    subtitle: 'NCCN Guidelines for B-Cell Lymphomas — HIV-Associated',
    category: 'B-Cell Lymphoma',
    version: '1.2025',
    pageCount: 4,
    nccnUrl: 'https://www.nccn.org/professionals/physician_gls/pdf/b-cell.pdf',
  },
  {
    id: 'ptld',
    name: 'Post-Transplant Lymphoproliferative Disorders',
    subtitle: 'NCCN Guidelines for B-Cell Lymphomas — PTLD',
    category: 'B-Cell Lymphoma',
    version: '1.2025',
    pageCount: 4,
    nccnUrl: 'https://www.nccn.org/professionals/physician_gls/pdf/b-cell.pdf',
  },
  {
    id: 'hgbl',
    name: 'High-Grade B-Cell Lymphoma',
    subtitle: 'NCCN Guidelines for B-Cell Lymphomas — HGBL (Double/Triple-Hit)',
    category: 'B-Cell Lymphoma',
    version: '1.2025',
    pageCount: 4,
    nccnUrl: 'https://www.nccn.org/professionals/physician_gls/pdf/b-cell.pdf',
  },
  {
    id: 'ht-dlbcl',
    name: 'Histologic Transformation to DLBCL',
    subtitle: 'NCCN Guidelines for B-Cell Lymphomas — Histologic Transformation',
    category: 'B-Cell Lymphoma',
    version: '1.2025',
    pageCount: 3,
    nccnUrl: 'https://www.nccn.org/professionals/physician_gls/pdf/b-cell.pdf',
  },
  {
    id: 'wm',
    name: "Waldenstrom's Macroglobulinemia / LPL",
    subtitle: "NCCN Guidelines for Waldenstrom's Macroglobulinemia",
    category: 'B-Cell Lymphoma',
    version: '1.2025',
    pageCount: 5,
    nccnUrl: 'https://www.nccn.org/professionals/physician_gls/pdf/waldenstroms.pdf',
  },
  {
    id: 'hcl',
    name: 'Hairy Cell Leukemia',
    subtitle: 'NCCN Guidelines for Hairy Cell Leukemia',
    category: 'B-Cell Lymphoma',
    version: '1.2025',
    pageCount: 3,
    nccnUrl: 'https://www.nccn.org/professionals/physician_gls/pdf/hairy_cell.pdf',
  },
  {
    id: 'pcnsl',
    name: 'Primary CNS Lymphoma',
    subtitle: 'NCCN Guidelines for Primary CNS Lymphoma',
    category: 'B-Cell Lymphoma',
    version: '1.2025',
    pageCount: 4,
    nccnUrl: 'https://www.nccn.org/professionals/physician_gls/pdf/cns.pdf',
  },
  {
    id: 'ptcl',
    name: 'Peripheral T-Cell Lymphoma',
    subtitle: 'NCCN Guidelines for T-Cell Lymphomas — PTCL Algorithm',
    category: 'T-Cell Lymphoma',
    version: '3.2025',
    pageCount: 5,
    nccnUrl: 'https://www.nccn.org/professionals/physician_gls/pdf/t-cell.pdf',
  },
  {
    id: 'atll',
    name: 'Adult T-Cell Leukemia/Lymphoma',
    subtitle: 'NCCN Guidelines for T-Cell Lymphomas — ATLL Algorithm',
    category: 'T-Cell Lymphoma',
    version: '3.2025',
    pageCount: 4,
    nccnUrl: 'https://www.nccn.org/professionals/physician_gls/pdf/t-cell.pdf',
  },
  {
    id: 'enktl',
    name: 'Extranodal NK/T-Cell Lymphoma',
    subtitle: 'NCCN Guidelines for T-Cell Lymphomas — ENKTL Algorithm',
    category: 'T-Cell Lymphoma',
    version: '3.2025',
    pageCount: 4,
    nccnUrl: 'https://www.nccn.org/professionals/physician_gls/pdf/t-cell.pdf',
  },
];

export const guidelineData = {
  dlbcl: { meta: dlbclIndex, nodes: dlbclNodes, edges: dlbclEdges },
  fl: { meta: flIndex, nodes: flNodes, edges: flEdges },
  mcl: { meta: mclIndex, nodes: mclNodes, edges: mclEdges },
  mzl: { meta: mzlIndex, nodes: mzlNodes, edges: mzlEdges },
  burkitt: { meta: burkittIndex, nodes: burkittNodes, edges: burkittEdges },
  pmbcl: { meta: pmbclIndex, nodes: pmbclNodes, edges: pmbclEdges },
  cll: { meta: cllIndex, nodes: cllNodes, edges: cllEdges },
  hl: { meta: hlIndex, nodes: hlNodes, edges: hlEdges },
  'mf-ss': { meta: mfssIndex, nodes: mfssNodes, edges: mfssEdges },
  'hiv-bcl': { meta: hivBclIndex, nodes: hivBclNodes, edges: hivBclEdges },
  ptld: { meta: ptldIndex, nodes: ptldNodes, edges: ptldEdges },
  hgbl: { meta: hgblIndex, nodes: hgblNodes, edges: hgblEdges },
  'ht-dlbcl': { meta: htDlbclIndex, nodes: htDlbclNodes, edges: htDlbclEdges },
  wm: { meta: wmIndex, nodes: wmNodes, edges: wmEdges },
  hcl: { meta: hclIndex, nodes: hclNodes, edges: hclEdges },
  pcnsl: { meta: pcnslIndex, nodes: pcnslNodes, edges: pcnslEdges },
  ptcl: { meta: ptclIndex, nodes: ptclNodes, edges: ptclEdges },
  atll: { meta: atllIndex, nodes: atllNodes, edges: atllEdges },
  enktl: { meta: enktlIndex, nodes: enktlNodes, edges: enktlEdges },
};

// Version and page count come from each guideline's own index.json so the list
// page and the guideline header can never disagree (they did for Hodgkin).
export const CONTENT_REVIEWED = '2026-07-26';

export const guidelineRegistry = registryBase.map((g) => {
  const meta = guidelineData[g.id] && guidelineData[g.id].meta;
  return {
    ...g,
    version: meta ? meta.version : 'unknown',
    nccnId: meta ? meta.nccnId : undefined,
    pageCount: meta && meta.pages ? meta.pages.length : 0,
    contentReviewed: CONTENT_REVIEWED,
  };
});
